module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAAXNSR0IArs4c6QAAAEtQTFRFAAAAICAgKioqMDAwMzMzNTU1Li4uMTExMjIyMjIyNDQ0MTExNDQ0MjIyMjIyMzMzMjIyMzMzMzMzMzMzMjIyMjIyMzMzMzMzMzMzaS+QzQAAABh0Uk5TAAgMEBQYLDQ4R09TU4+jr7Pj5+vv8/f7XlWhxAAAAKVJREFUSMftlNEOwiAMRTvF6SyomxP6/19qRqZSHrrrg4kP3MfmnBRoA1FLy09y7KvCvjP5iySvChzvg8GfRLTBSWQ2evRJGwsv0RktvDIyn9i8RGkgfGlg/MdA+ZcRYH41BOffBswThSwEmOe1g/+Ohw0uXsnDPFdbss0TaJTzRQy9D9uGi3pe2RgNoZur+S7G1TrS8Kj24TzdDuYldq79nC1/mydU3ROUh3TIHgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/Frame@2x(1).png
// module id = 0+cm
// module chunks = 1